<script setup>
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import ActionMessage from "@Components/ActionMessage.vue";
import { FormCard } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";
import TemplateTitleFormPart from "./TemplateTitleFormPart.vue";
import TemplateDisplayModeFormPart from "./TemplateDisplayModeFormPart.vue";
import TemplateElementsFormPart from "./TemplateElementsFormPart.vue";
import TemplatePreviewFormPart from "./TemplatePreviewFormPart.vue";
import TemplateThemeFormPart from "./TemplateThemeFormPart.vue";

const props = defineProps({
    settings: Object,
});

const { t: __ } = useI18n();

const form = useForm(props.settings);

const submit = () => {
    if (form.processing) return;
    form.post("linking_automatic_posts_update_template");
};
</script>

<template>
    <FormCard :title="__('Template')">
        <form @submit.prevent="submit">
            <div class="flex flex-col xl:flex-row">
                <div class="flex-1 space-y-6">
                    <TemplateTitleFormPart v-model="form" />

                    <TemplateDisplayModeFormPart v-model="form" />

                    <TemplateElementsFormPart v-model="form" />

                    <TemplateThemeFormPart v-model="form" />
                </div>
                <TemplatePreviewFormPart class="w-64 flex-none mt-6 xl:mt-0 xl:ml-6" v-model="form" />
            </div>

            <div class="flex justify-end items-center mt-6">
                <ActionMessage :on="form.recentlySuccessful" class="mr-3"> {{ __("Sauvegardé.") }} </ActionMessage>

                <PrimaryButton :processing="form.processing"> {{ __("Sauvegarder") }} </PrimaryButton>
            </div>
        </form>
    </FormCard>
</template>
